import { useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../assets/img/logo.jpeg'
import logoMin from '../../assets/img/logo-min.png'
import NavMenu from './NavMenu';
import { AppContext, DashboardContext } from '../../context';
import { Link } from 'react-router-dom';
import { APPTEXT } from '../../config/text/apptext.config';
import { GAHelper } from '../../helpers/ga.helper';
import { ALL_VALUES, URLAPP } from '../../config';

export default function SideBar() {
    const appContext = useContext(AppContext)
    const context = useContext(DashboardContext)
    useEffect(() => {
        GAHelper.setAccess(context?.appData.afore || ALL_VALUES, appContext?.user.data?.user)
    }, [])
    return (
        <nav className={`nav ${context?.navBar.expanded ? 'expanded' : 'minified'}`}>
            <Link to='/dashboard' className='nav-logo'>
                <img src={context?.navBar.expanded ? logo : logoMin} alt="logo" className='nav-logo-main' />
            </Link>
            <div className='nav-expand'>
                <button
                    className='nav-expand-control'
                    onClick={() => context?.setNavBar({ ...context.navBar, expanded: !context?.navBar.expanded, parentOpen: false })}
                >
                    <FontAwesomeIcon
                        icon={`chevron-circle-${context?.navBar.expanded ? 'left' : 'right'}`}
                        className='m-auto'
                    />
                </button>
                <button
                    className='nav-expand-responsive'
                    onClick={() => context?.setNavBar({ ...context.navBar, openResponsiveMenu: !context?.navBar.openResponsiveMenu })}
                >
                    <FontAwesomeIcon
                        icon={`bars`}
                        className='m-auto'
                    />
                </button>
            </div>
            <div className={`nav-options ${context?.navBar.openResponsiveMenu && 'responsiveDisplay'}`}>
                <NavMenu items={context?.appData['menu'] || []} open={!!context?.navBar.parentOpen} />
                <div className='nav-logout'>
                    <NavMenu
                        items={[
                            {
                                id: -1,
                                label: `${appContext?.user.data?.user || 'Usuario'}`,
                                icon: 'user',
                                path: URLAPP.profile,
                                decorator: {
                                    icon: 'bell',
                                    value: context?.appData.notificationsUnread || 0
                                },
                                breadcrumbs: []
                            },
                            {
                                id: -2,
                                label: APPTEXT.HOME.CLOSE_SESSION,
                                icon: 'sign-out-alt',
                                action: context?.logout,
                                breadcrumbs: []
                            }
                        ]}
                        open={true}
                    />
                </div>
            </div>
        </nav>
    )
}
